import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

// Actions & service & constants
import {
  loadAndSaveCampusesList,
  loadAndSavePractitionersList,
  updateCommonFilters
} from '../../../reducer/commonActions';

// Components
import PractitionersList from './PractitionersList';
import CampusesSelect from './CampusesSelect';

// Styles
// import rsStyles from './styles';

class FiltersSection extends Component {
  constructor() {
    super();
    this.state = {
      isLoadAllData: false
    };
  }

  componentDidMount() {
    const {
      loadAndSaveCampusesList,
      loadAndSavePractitionersList,
      practitioner: {
        common: { campusesList, practitionersList }
      }
    } = this.props;

    // load campuses if don't load yet
    if (!campusesList) {
      loadAndSaveCampusesList();
    }
    // load practitioners if don't load yet
    if (!practitionersList) {
      loadAndSavePractitionersList();
    }
    this.checkInitData = this.checkInitData.bind(this);
    this.onChangeCampusId = this.onChangeCampusId.bind(this);
    this.onChangePractitioner = this.onChangePractitioner.bind(this);

    this.checkInitData();
  }

  componentDidUpdate() {
    this.checkInitData();
  }

  checkInitData() {
    const {
      practitioner: {
        common: { campusesList, practitionersList }
      }
    } = this.props;
    const { isLoadAllData } = this.state;

    if (campusesList && practitionersList && !isLoadAllData) {
      this.setState({ isLoadAllData: true });
    }
  }

  onChangePractitioner(practitioner) {
    const { updateCommonFilters } = this.props;
    updateCommonFilters({ practitionerId: practitioner.id });
  }

  onChangeCampusId(campus) {
    const { updateCommonFilters } = this.props;
    updateCommonFilters({ campusId: campus && campus.id });
  }

  render() {
    const {
      // i18n,
      practitioner: {
        common: {
          campusesList,
          practitionersList,
          commonFilters: { practitionerId, campusId }
        }
      }
    } = this.props;

    const { isLoadAllData } = this.state;
    return isLoadAllData ? (
      <Fragment>
        <PractitionersList
          practitioners={practitionersList}
          practitionerId={practitionerId}
          onChangePractitioner={this.onChangePractitioner}
        />
        <CampusesSelect
          campuses={campusesList}
          onChangeCampus={this.onChangeCampusId}
          selectedCampusId={campusId}
        />
        {/* <rsStyles.LinkLikeBtnWrapper>
          <Link to="/practitioner/reporting">{i18n.t('payment_report')}</Link>
        </rsStyles.LinkLikeBtnWrapper> */}
      </Fragment>
    ) : null;
  }
}

const mapStateToProps = state => ({
  currentPractitioner: state.auth.practitioner,
  practitioner: state.practitioner
});

const mapDispatchToProps = dispatch => ({
  loadAndSaveCampusesList: () => dispatch(loadAndSaveCampusesList()),
  loadAndSavePractitionersList: () => dispatch(loadAndSavePractitionersList()),
  updateCommonFilters: objData => dispatch(updateCommonFilters(objData))
});

export default translate()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FiltersSection)
);
